module.exports = __webpack_public_path__ + "img/battery-low.75aa1bc1.svg";